import React from 'react'

export default function NigmabotLogo({ className, size = 22, ...props }) {
    return (
        <svg
            className={className}
            width={size}
            height={size}
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <text
                x="50%"
                y="54%"
                dominantBaseline="middle"
                textAnchor="middle"
                fill="currentColor"
                fontFamily="Montserrat, sans-serif"
                fontWeight="800"
                fontSize="22"
            >
                N
            </text>
            <circle cx="20" cy="20" r="17" stroke="currentColor" strokeWidth="2.5" fill="none" />
        </svg>
    )
}
